import React from 'react';
import { Stack } from '@mui/material';

function Row({ sx, ...props }) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: '100%',
        ...sx,
      }}
      {...props}
    />
  );
}

export default Row;
